/* Auro bamboo boxer PDP (abx-*): scroll-to-buy, pack buttons, sliders, stat count-up, bar fill, before/after, size dialog. */
(function () {
  if (window.__abxInit) return;
  window.__abxInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function buyTarget() {
    return document.querySelector('nf-bundle-cards') ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('[id^="BuyButtons-ProductSubmitButton-"]') ||
      document.querySelector('main');
  }

  function scrollToBuy() {
    var t = buyTarget();
    if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }

  // Picks a pack in the buy box's Bundle cards (matching quantity), so cart and checkout use it.
  function choosePack(qty) {
    var input = document.querySelector('nf-bundle-cards .nf-bundle__input[value="' + qty + '"]');
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var pack = e.target.closest('[data-abx-pack]');
    if (pack) {
      e.preventDefault();
      choosePack(pack.getAttribute('data-abx-pack'));
      scrollToBuy();
      return;
    }
    if (e.target.closest('[data-abx-buy]')) {
      e.preventDefault();
      scrollToBuy();
      return;
    }
    var opener = e.target.closest('[data-abx-dialog-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-abx-dialog-open'));
      if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
      return;
    }
    if (e.target.closest('[data-abx-dialog-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    // Click on the backdrop closes the dialog.
    if (e.target.matches && e.target.matches('dialog.abx-dialog[open]')) e.target.close();
  });

  function initSliders(root) {
    root.querySelectorAll('[data-abx-slider]').forEach(function (s) {
      if (s.__abx) return;
      s.__abx = true;
      var track = s.querySelector('.abx-slider__track');
      var prev = s.querySelector('[data-abx-prev]');
      var next = s.querySelector('[data-abx-next]');
      if (!track || !prev || !next) return;
      function step() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      }
      function update() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function decimals(str) {
    var m = String(str).match(/\.(\d+)/);
    return m ? m[1].length : 0;
  }

  function fmt(n, dec) {
    return n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }

  function runCount(el) {
    var from = parseFloat(el.dataset.from) || 0, to = parseFloat(el.dataset.to) || 0;
    var dec = Math.max(decimals(el.dataset.from), decimals(el.dataset.to));
    var dur = (parseFloat(el.dataset.speed) || 2) * 1000, suffix = el.dataset.suffix || '';
    if (reduce || from === to || dur <= 0) { el.textContent = fmt(to, dec) + suffix; return; }
    var t0 = null;
    function frame(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      el.textContent = fmt(from + (to - from) * (1 - Math.pow(1 - p, 3)), dec) + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function onVisible(els, fn, threshold) {
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(fn); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); fn(en.target); } });
    }, { threshold: threshold });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCounters(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-abx-count]:not([data-abx-done])'));
    els.forEach(function (el) {
      el.setAttribute('data-abx-done', '');
      el.textContent = fmt(parseFloat(el.dataset.to) || 0, Math.max(decimals(el.dataset.from), decimals(el.dataset.to))) + (el.dataset.suffix || '');
    });
    onVisible(els, runCount, 0.4);
  }

  function initBars(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-abx-bars]:not(.is-in)'));
    if (reduce || window.Shopify && window.Shopify.designMode) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    onVisible(els, function (el) { el.classList.add('is-in'); }, 0.25);
  }

  function initCompare(root) {
    root.querySelectorAll('[data-abx-compare]').forEach(function (c) {
      if (c.__abx) return;
      c.__abx = true;
      var range = c.querySelector('.abx-compare__range');
      if (!range) return;
      function set() { c.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', set);
      set();
    });
  }

  function init(root) {
    root = root || document;
    initSliders(root);
    initCounters(root);
    initBars(root);
    initCompare(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
